/* Stykhia product page scripts.
   Nothing here touches the product form or the add to cart flow. */

/* Price inside the Add to Cart button ("Add to Cart · $89"). Only the text of the separate
   .sm-btn-price span changes, on Dawn's variant-change event, so Dawn's own updates of the
   button text (they only touch the first span) never overwrite it. */
(function () {
  if (window.smBtnPriceBound) return;

  function format(cents) {
    var value = cents / 100;
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: value % 1 === 0 ? 0 : 2,
      }).format(value);
    } catch (e) {
      return '$' + value;
    }
  }

  window.smFormatMoney = format; /* also used by assets/sm-portrait.js */

  function bind() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    window.smBtnPriceBound = true;
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var data = event && event.data;
      if (!data || !data.variant) return;
      var button = document.getElementById('ProductSubmitButton-' + data.sectionId);
      var span = button && button.querySelector('[data-sm-btn-price]');
      if (!span) return;
      span.textContent = ' · ' + format(data.variant.price);
      span.hidden = !data.variant.available;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();

/* Delivery estimate: counts business days from today, skipping Saturday and Sunday. */
(function () {
  function addBusinessDays(start, days) {
    var date = new Date(start.getFullYear(), start.getMonth(), start.getDate());
    var left = days;
    while (left > 0) {
      date.setDate(date.getDate() + 1);
      var day = date.getDay();
      if (day !== 0 && day !== 6) left -= 1;
    }
    return date;
  }

  function format(date) {
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  }

  function init(root) {
    var target = root.querySelector('[data-sm-delivery-dates]');
    var min = parseInt(root.dataset.daysMin, 10);
    var max = parseInt(root.dataset.daysMax, 10);
    if (!target || isNaN(min) || isNaN(max)) return;
    var today = new Date();
    target.textContent = 'arrives ' + format(addBusinessDays(today, min)) + ' – ' + format(addBusinessDays(today, max));
  }

  function run() {
    document.querySelectorAll('[data-sm-delivery]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  document.addEventListener('shopify:section:load', run);
})();

/* Mobile gallery: dots under the swipe slider. Decorative only, swiping is native. */
(function () {
  function init(gallery) {
    var slider = gallery.querySelector('.product__media-list');
    var host = gallery.querySelector('slider-component');
    if (!slider || !host || gallery.querySelector('.sm-dots')) return;

    var dots = document.createElement('div');
    dots.className = 'sm-dots';
    dots.setAttribute('aria-hidden', 'true');
    host.insertAdjacentElement('afterend', dots);

    var frame = null;

    function slides() {
      return Array.prototype.filter.call(slider.querySelectorAll('.product__media-item'), function (item) {
        return item.offsetWidth > 0;
      });
    }

    function render() {
      var count = slides().length;
      if (dots.children.length !== count) {
        dots.innerHTML = '';
        for (var i = 0; i < count; i++) dots.appendChild(document.createElement('span'));
      }
      dots.hidden = count < 2;
      update();
    }

    function update() {
      var items = slides();
      var left = slider.getBoundingClientRect().left;
      var active = 0;
      var best = Infinity;
      items.forEach(function (item, index) {
        var distance = Math.abs(item.getBoundingClientRect().left - left);
        if (distance < best) {
          best = distance;
          active = index;
        }
      });
      Array.prototype.forEach.call(dots.children, function (dot, index) {
        dot.classList.toggle('is-active', index === active);
      });
    }

    function schedule() {
      if (frame) return;
      frame = requestAnimationFrame(function () {
        frame = null;
        update();
      });
    }

    slider.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', render);
    new MutationObserver(render).observe(slider, { childList: true });
    render();
  }

  function run() {
    document.querySelectorAll('media-gallery').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  document.addEventListener('shopify:section:load', run);
})();

/* Menu links to the product page itself ("Create my portrait") scroll to the buy block instead of
   reloading the page. Without JS they stay ordinary links to the product. */
(function () {
  function run() {
    var buy = document.getElementById('buy');
    if (!buy) return;
    document.querySelectorAll('header a[href], .menu-drawer a[href]').forEach(function (link) {
      var url;
      try {
        url = new URL(link.href, location.origin);
      } catch (e) {
        return;
      }
      if (url.origin === location.origin && url.pathname === location.pathname && !url.hash && !url.search) {
        link.setAttribute('href', '#buy');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();

/* Desktop gallery: ← → arrows on the main picture and the ← → keys while focus is inside the gallery.
   They go round in a circle and simply press the next thumbnail, so Dawn's own switch runs (active slide,
   thumbnail frame, video pause) and the style variation slides of assets/sm-variations.js work the same way.
   Phones keep the swipe; the arrows are hidden there by CSS. */
(function () {
  var ICON_PREV = '<svg viewBox="0 0 16 16" fill="none" aria-hidden="true" focusable="false"><path d="M10 3 5 8l5 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var ICON_NEXT = '<svg viewBox="0 0 16 16" fill="none" aria-hidden="true" focusable="false"><path d="m6 3 5 5-5 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function init(gallery) {
    var viewer = gallery.querySelector('[id^="GalleryViewer"]');
    var thumbs = gallery.querySelector('[id^="Slider-Thumbnails"]');
    if (!viewer || !thumbs || viewer.querySelector('.sm-gallery-arrows')) return;

    function items() {
      return Array.prototype.filter.call(thumbs.children, function (li) {
        return li.dataset.target && li.offsetParent !== null;
      });
    }

    function step(delta) {
      var list = items();
      if (list.length < 2) return;
      var active = viewer.querySelector('[data-media-id].is-active');
      var current = -1;
      list.forEach(function (li, index) {
        if (active && li.dataset.target === active.dataset.mediaId) current = index;
      });
      if (current < 0) {
        list.forEach(function (li, index) {
          if (li.querySelector('[aria-current]')) current = index;
        });
      }
      var next = list[(Math.max(current, 0) + delta + list.length) % list.length];
      var button = next.querySelector('button');
      if (button) button.click();
    }

    var wrap = document.createElement('div');
    wrap.className = 'sm-gallery-arrows';
    [
      ['prev', 'Previous photo', ICON_PREV, -1],
      ['next', 'Next photo', ICON_NEXT, 1],
    ].forEach(function (cfg) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'sm-gallery-arrow sm-gallery-arrow--' + cfg[0];
      button.setAttribute('aria-label', cfg[1]);
      button.innerHTML = cfg[2];
      button.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        step(cfg[3]);
      });
      wrap.appendChild(button);
    });
    viewer.appendChild(wrap);

    function render() {
      wrap.hidden = items().length < 2;
    }

    gallery.addEventListener('keydown', function (event) {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      if (event.target.closest('input, textarea, select, video, [contenteditable]')) return;
      event.preventDefault();
      step(event.key === 'ArrowLeft' ? -1 : 1);
      var current = thumbs.querySelector('button[aria-current]');
      if (current && gallery.contains(document.activeElement) && document.activeElement.closest('[id^="Slider-Thumbnails"]')) {
        current.focus();
      }
    });

    // wide screens stack the thumbnails in a scrolling column (assets/sm-product.css); Dawn only scrolls a row,
    // so the active thumbnail is brought into view here
    function reveal() {
      if (thumbs.scrollHeight <= thumbs.clientHeight) return;
      var current = thumbs.querySelector('button[aria-current]');
      var li = current && current.closest('li');
      if (!li) return;
      var top = li.offsetTop;
      var bottom = top + li.offsetHeight;
      if (top < thumbs.scrollTop) {
        thumbs.scrollTo({ top: top - 2, behavior: 'smooth' });
      } else if (bottom > thumbs.scrollTop + thumbs.clientHeight) {
        thumbs.scrollTo({ top: bottom - thumbs.clientHeight + 2, behavior: 'smooth' });
      }
    }

    new MutationObserver(render).observe(thumbs, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden', 'class'] });
    new MutationObserver(reveal).observe(thumbs, { subtree: true, attributes: true, attributeFilter: ['aria-current'] });
    window.addEventListener('resize', render);
    render();
  }

  function run() {
    document.querySelectorAll('.product__media-wrapper media-gallery').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  document.addEventListener('shopify:section:load', run);
})();

/* Lightbox (Dawn's product-modal): one photo at a time, whole, with ← → arrows and keys between the photos
   in a circle. The sizes are in assets/sm-product.css; Dawn still opens it on the clicked photo. */
(function () {
  var ICON_PREV = '<svg viewBox="0 0 16 16" fill="none" aria-hidden="true" focusable="false"><path d="M10 3 5 8l5 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var ICON_NEXT = '<svg viewBox="0 0 16 16" fill="none" aria-hidden="true" focusable="false"><path d="m6 3 5 5-5 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function init(modal) {
    var dialog = modal.querySelector('[role="dialog"]');
    var content = modal.querySelector('.product-media-modal__content');
    if (!dialog || !content || dialog.querySelector('.sm-modal-arrow')) return;

    /* what Dawn would show: hidden variant photos (hide_variants) stay out, except the first one */
    function items() {
      return Array.prototype.filter.call(content.children, function (el) {
        if (!el.hasAttribute('data-media-id')) return false;
        return !el.classList.contains('product__media-item--variant') || el === content.firstElementChild;
      });
    }

    /* videos: the box keeps the poster's proportions, so it fits 90vw × 90vh like a photo */
    function fit(el) {
      var poster = el.querySelector && el.querySelector('img[width][height]');
      if (!poster) return;
      var ratio = parseFloat(poster.getAttribute('width')) / parseFloat(poster.getAttribute('height'));
      if (ratio > 0) el.style.setProperty('--sm-ratio', ratio);
    }

    function show(el) {
      if (typeof window.pauseAllMedia === 'function') window.pauseAllMedia();
      items().forEach(function (item) {
        item.classList.toggle('active', item === el);
      });
      fit(el);
    }

    function step(delta) {
      var list = items();
      if (list.length < 2) return;
      var current = list.findIndex(function (el) {
        return el.classList.contains('active');
      });
      show(list[(Math.max(current, 0) + delta + list.length) % list.length]);
    }

    var buttons = [
      ['prev', 'Previous photo', ICON_PREV, -1],
      ['next', 'Next photo', ICON_NEXT, 1],
    ].map(function (cfg) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'sm-modal-arrow sm-modal-arrow--' + cfg[0];
      button.setAttribute('aria-label', cfg[1]);
      button.innerHTML = cfg[2];
      button.addEventListener('click', function () {
        step(cfg[3]);
      });
      /* Dawn closes the media modal on any mouse pointerup inside it */
      button.addEventListener('pointerup', function (event) {
        event.stopPropagation();
      });
      dialog.appendChild(button);
      return button;
    });

    modal.addEventListener('keydown', function (event) {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      if (event.target.closest('input, textarea, select, video, model-viewer')) return;
      event.preventDefault();
      step(event.key === 'ArrowLeft' ? -1 : 1);
    });

    new MutationObserver(function () {
      if (!modal.hasAttribute('open')) return;
      var single = items().length < 2;
      buttons.forEach(function (button) {
        button.hidden = single;
      });
      var active = content.querySelector('.active');
      if (active) fit(active);
    }).observe(modal, { attributes: true, attributeFilter: ['open'] });
  }

  function run() {
    document.querySelectorAll('product-modal.product-media-modal').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  document.addEventListener('shopify:section:load', run);
})();
